// Hamburger menu for small screens: toggles the header links as a list.
// Closes on link click (same-page anchors), Escape, or a click outside.
// Also swaps the header's account links when signed in (lib/session-hint.ts).
import { bindNavToggle } from '../lib/nav'
import { bindScrollTop } from '../lib/scroll-top'
import { applySessionHint } from '../lib/session-hint'

applySessionHint()

document.querySelectorAll<HTMLButtonElement>('[data-nav-toggle]').forEach(bindNavToggle)
document.querySelectorAll<HTMLAnchorElement>('[data-scroll-top]').forEach((link) => bindScrollTop(link))
